import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import fireEvent from 'src/analytics/fireEvent';
import useGetFeatureValue from 'src/commons/experimentation/hooks/useGetFeatureValue';
import useQueryParameters from 'src/util/hooks/useQueryParameters';
import { forbiddenRedirectUploadByEmployee } from '../analytics/events';
import useVerifyUnauthenticatedUploaderAvailability from '../hooks/useVerifyUnauthenticatedUploaderAvailability';
import UploadCertificatePage from '../upload-certificate/UploadCertificateVerification';

type GrowthbookFeatureReturnType = {
  clientIds: number[];
};

type MutationData = {
  verifyUnauthenticatedUploaderAvailability: {
    clientId: number;
    errors: [];
  };
};

const UPLOAD_ROUTE = '/enviar_atestado/upload';
const FORBIDDEN_ROUTE = '/enviar_atestado/403';

export default function () {
  const urlParams = useQueryParameters();
  const id = urlParams.get('id');
  const navigate = useNavigate();

  const { clientIds } = useGetFeatureValue<GrowthbookFeatureReturnType>(
    'upload-certificates-deny-list',
    {
      clientIds: [],
    },
  );

  const onMutationComplete = (data: MutationData) => {
    const {
      verifyUnauthenticatedUploaderAvailability: { clientId },
    } = data;

    const companyExistsAndHasFeature = !!clientId;
    const denyListHasClientId = clientIds.includes(clientId);

    const uploadDisabled = !companyExistsAndHasFeature || denyListHasClientId;

    if (uploadDisabled) return navigateToForbiddenRoute();

    return navigate(UPLOAD_ROUTE, {
      state: {
        clientId,
        uuid: id,
      },
    });
  };

  const navigateToForbiddenRoute = () => {
    fireEvent({
      ...forbiddenRedirectUploadByEmployee,
    });
    navigate(FORBIDDEN_ROUTE);
  };

  const {
    verifyUnauthenticatedUploaderAvailability,
    loading,
  } = useVerifyUnauthenticatedUploaderAvailability({
    onCompleted: onMutationComplete,
    onError: () => navigateToForbiddenRoute(),
  });

  useEffect(() => {
    if (id) {
      verifyUnauthenticatedUploaderAvailability({
        uuid: id as string,
      });
    }
  }, [id]);

  return <UploadCertificatePage loading={loading} />;
}
